/**
 * Update Project Completed Field Function
 * Handles updating the project completion status via AJAX
 */

// AJAX function to update the project_completed ACF field
function updateProjectCompletedField(projectId) {
	function is2026SubVersionSlug(slug) {
		return slug === 'crf-s-appsec-2026' ||
			slug === 'crf-s-gov-2026' ||
			slug === 'crf-s-hyg-2026' ||
			slug === 'crf-s-smb-2026';
	}

	function getTechnicalTableOverallScore() {
		var total = 0;
		var count = 0;
		jQuery('#technical tbody tr').each(function () {
			// Exclude rows hidden by sub-version filtering; include rows even if table section is collapsed.
			if (this.style && this.style.display === 'none') return;
			var text = jQuery(this).find('td[class^="crf-domain-"]').text();
			var value = parseFloat(text);
			if (!Number.isNaN(value)) {
				total += value;
				count++;
			}
		});
		return count > 0 ? parseFloat((total / count).toFixed(2)) : null;
	}

	function getSubversionDomainOverallFallback() {
		var raw = (typeof WebAssessmentCharts !== 'undefined' && WebAssessmentCharts.overallCRFDomainScore) ||
			window.overallCRFDomainScore ||
			jQuery('.crf-domain-overall').first().text();
		var parsed = parseFloat(raw);
		return Number.isNaN(parsed) ? null : parsed;
	}

	// Full-precision CRF-S overall (crfMaturityLevelScores.js sets <key>Exact beside
	// each 2dp <key>), first match in the given order; null when none is set.
	function getExactCRFSOverall(keys) {
		for (var i = 0; i < keys.length; i++) {
			var value = window[keys[i] + 'Exact'];
			if (typeof value === 'number' && isFinite(value) && value > 0) {
				return value;
			}
		}
		return null;
	}

	let overallMaturityScore;
	if (jQuery('body').hasClass('single-projects')) {
		projectId = getPostIdFromBodyClass(); // Fallback to extracting post ID if needed
		console.log('Fallback projectId is:', projectId);
		var framework_slug = jQuery('.project-menu').data('framework-slug');
		var framework_id = jQuery('.project-menu').data('framework-id');
		var isSubversion2026 = is2026SubVersionSlug(framework_slug);

		// For 2026 sub-versions, always use technical-domain average as source of truth.
		if (isSubversion2026) {
			overallMaturityScore = getTechnicalTableOverallScore();
			if (overallMaturityScore == null) {
				overallMaturityScore = getSubversionDomainOverallFallback();
			}
			console.log('Using technical table overall for 2026 sub-version:', overallMaturityScore);
		} else if (WebAssessmentCharts.calculatedOverallMaturityScore !== null && WebAssessmentCharts.calculatedOverallMaturityScore !== undefined) {
			overallMaturityScore = WebAssessmentCharts.calculatedOverallMaturityScore;
			console.log('Using calculatedOverallMaturityScore:', overallMaturityScore);
		} else {
			// Try to get from framework-specific variables (check both WebAssessmentCharts and window)
			// crf-s / crf-s-2024
			if (framework_slug === 'crf-s' || framework_slug === 'crf-s-2024') {
				console.log('crf-s/crf-s-2024 detected');
				overallMaturityScore = getExactCRFSOverall(['overallCRFS2024maturity', 'overallCRFS2025maturity']) || WebAssessmentCharts.overallCRFS2024maturity || window.overallCRFS2024maturity || window.overallCRFS2025maturity;
				console.log('overallMaturityScore for CRF-S 2024 is '+overallMaturityScore);
			}
			// crf-s 2025
			else if (framework_slug === 'crf-s-2025') {
				console.log('crf-s 2025 detected');
				overallMaturityScore = getExactCRFSOverall(['overallCRFS2025maturity']) || WebAssessmentCharts.overallCRFS2025maturity || window.overallCRFS2025maturity;
				console.log('overallMaturityScore for CRF-S 2025 is '+overallMaturityScore);
			}
			// crf-s 2026 (Core + sub-versions: AppSec, Gov, Hyg, SMB)
			else if (framework_slug === 'crf-s-2026' || framework_slug === 'crf-s-appsec-2026' || framework_slug === 'crf-s-gov-2026' || framework_slug === 'crf-s-hyg-2026' || framework_slug === 'crf-s-smb-2026') {
				console.log('crf-s 2026 detected');
				if (is2026SubVersionSlug(framework_slug)) {
					overallMaturityScore = getTechnicalTableOverallScore();
				} else {
					overallMaturityScore = getExactCRFSOverall(['overallCRFS2026maturity']);
				}
				overallMaturityScore = overallMaturityScore || WebAssessmentCharts.overallCRFS2026maturity || window.overallCRFS2026maturity;
				console.log('overallMaturityScore for CRF-S 2026 is '+overallMaturityScore);
			}
			// cis 7.0
			else if (framework_slug === 'cis-7-0') {
				console.log('cis 7.0 detected');
				overallMaturityScore = WebAssessmentCharts.overallCIS70maturity || window.overallCIS70maturity;
				console.log('overallMaturityScore for CIS 7.0 is '+overallMaturityScore);
			}
			// cis 7.1
			else if (framework_slug === 'cis-7-1') {
				console.log('cis 7.1 detected');
				overallMaturityScore = WebAssessmentCharts.overallCIS71maturity || window.overallCIS71maturity;
				console.log('overallMaturityScore for CIS 7.1 is '+overallMaturityScore);
			}
			// cis 8.0
			else if (framework_slug === 'cis-8-0') {
				console.log('cis 8.0 detected');
				overallMaturityScore = WebAssessmentCharts.overallCIS80maturity || window.overallCIS80maturity;
				console.log('overallMaturityScore for CIS 8.0 is '+overallMaturityScore);
			}
			// cis 8.1
			else if (framework_slug === 'cis-8-1') {
				console.log('cis 8.1 detected');
				overallMaturityScore = WebAssessmentCharts.overallCIS81maturity || window.overallCIS81maturity;
				console.log('overallMaturityScore for CIS 8.1 is '+overallMaturityScore);
			}
			// nist 1
			else if (framework_slug === 'nist-csf-1-0') {
				console.log('nist 1 detected');
				overallMaturityScore = WebAssessmentCharts.overallNIST1maturity || window.overallNIST1maturity;
				console.log('overallMaturityScore for NIST 1 is '+overallMaturityScore);
			}
			// nist 1.1
			else if (framework_slug === 'nist-csf-1-1') {
				console.log('nist 1.1 detected');
				overallMaturityScore = WebAssessmentCharts.overallNIST11maturity || window.overallNIST11maturity;
				console.log('overallMaturityScore for NIST 1.1 is '+overallMaturityScore);
			}
			// nist 2
			else if (framework_slug === 'nist-csf-2-0') {
				console.log('nist 2 detected');
				overallMaturityScore = WebAssessmentCharts.overallNIST2maturity || window.overallNIST2maturity;
				console.log('overallMaturityScore for NIST 2 is '+overallMaturityScore);
			}
			// nydfs/nycrr
			else if (framework_slug === 'nycrr-500-v2') {
				console.log('nydfs/nycrr detected');
				overallMaturityScore = WebAssessmentCharts.overallNYCRR5002maturity || window.overallNYCRR5002maturity;
				console.log('overallMaturityScore for NYDFS/NYCFR is '+overallMaturityScore);
			}
			// SA NCA ECC 1.0
			else if (framework_slug === 'sa-nca-ecc-1-0') {
				console.log('sa-nca-ecc detected');
				overallMaturityScore = WebAssessmentCharts.overallSANCAECCmaturity || window.overallSANCAECCmaturity;
				console.log('overallMaturityScore for SA NCA ECC 1.0 is '+overallMaturityScore);
			}
			// PCI DSS v4.0
			else if (framework_slug === 'pci-dss-4-0') {
				console.log('pci-dss detected');
				overallMaturityScore = WebAssessmentCharts.overallPCIDSSmaturity || window.overallPCIDSSmaturity;
				console.log('overallMaturityScore for PCI DSS v4.0 is '+overallMaturityScore);
			}
			// SAMA CRFR v1.0
			else if (framework_slug === 'sama-crfr-1-0') {
				console.log('sama-crfr detected');
				overallMaturityScore = WebAssessmentCharts.overallSAMACRFRmaturity || window.overallSAMACRFRmaturity;
				console.log('overallMaturityScore for SAMA CRFR v1.0 is '+overallMaturityScore);
			}
			// NIST SP 800-171 (rev3)
			else if (framework_slug === 'nist-800-171-rev3') {
				console.log('nist-800-171-rev3 detected');
				overallMaturityScore = WebAssessmentCharts.overallNIST800171Rev3maturity || window.overallNIST800171Rev3maturity;
				console.log('overallMaturityScore for NIST SP 800-171 (rev3) is '+overallMaturityScore);
			}

			// Final fallback: read from the displayed UI element in the View Results modal
			if (!overallMaturityScore) {
				var displayedScore = jQuery('#viewResultsModal #overall-maturity-score').text() ||
					jQuery('#viewResultsModal .audit-overall-value').text() ||
					jQuery('#viewResultsModal .crf-maturitylevel-overall').text() ||
					jQuery('#viewResultsModal .cis81-overall-value').text();
				if (displayedScore) {
					overallMaturityScore = parseFloat(displayedScore);
					console.log('Read overallMaturityScore from displayed UI:', overallMaturityScore);
				}
			}
		}
		// Use controlsData for ajax_url/user_id, but projectDashboardNonce for the nonce
		// (controlsData.nonce uses 'projectData' action, but AJAX handler expects 'project_dashboard_nonce')
		fetch(controlsData.ajax_url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			body: new URLSearchParams({
				action: 'update_project_completed',
				completed: true,
				project_id: projectId,
				current_user_id: controlsData.current_user_id,
				framework_id: framework_id,
				framework_slug: framework_slug,
				overallMaturityScore: overallMaturityScore,
				nonce: projectDashboardNonce.nonce,
			}),
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error('Network response was not ok');
				}
				return response.json();
			})
			.then((data) => {
			if (data.success) {
				console.log('Project completed field updated successfully:', data);
				triggerConfetti();
				// Update the completeConfirmModal (shown from the View Results modal overlay)
				jQuery('#completeConfirmModal .modal-body').text('Assessment data has been successfully finalized.');
				jQuery('#completeConfirmModal .modal-footer').hide();
				if (jQuery('#viewResultsModal').is(':visible')) {
					sessionStorage.setItem('openViewResultsAfterReload', '1');
				}
				setTimeout(function() {
					window.location.reload();
				}, 1000);
			} else {
				console.error('Error updating project completed field:', data);
				if (data.data.message === 'User is not project owner') {
					jQuery('.permissions-user-not-owner').slideDown();
				}
			}
		})
		.catch((error) => {
			console.error('Error updating project completed field:', error);
		});
} else {
		var framework_slug = WebAssessmentCharts.frameworkSlug;
		var framework_id = WebAssessmentCharts.frameworkId;
		var isSubversion2026 = is2026SubVersionSlug(framework_slug);
		console.log('framework slug is: '+framework_slug);

		// For 2026 sub-versions, always use technical-domain average as source of truth.
		if (isSubversion2026) {
			overallMaturityScore = getTechnicalTableOverallScore();
			if (overallMaturityScore == null) {
				overallMaturityScore = getSubversionDomainOverallFallback();
			}
			console.log('Using technical table overall for 2026 sub-version:', overallMaturityScore);
		} else if (WebAssessmentCharts.calculatedOverallMaturityScore !== null) {
			overallMaturityScore = WebAssessmentCharts.calculatedOverallMaturityScore;
		} else {
			// Fallback to existing logic if the score hasn't been captured from the promise
			// crf-s
			if (framework_slug === 'crf-s' || framework_slug === 'crf-s-2024') {
				console.log('crf-s detected');
				overallMaturityScore = WebAssessmentCharts.overallCRFS2024maturity;
				console.log('overallMaturityScore for CRF-S 2024 is '+WebAssessmentCharts.overallCRFS2024maturity);
			}
			// crf-s 2025
			else if (framework_slug === 'crf-s-2025') {
				console.log('crf-s 2025 detected');
				overallMaturityScore = WebAssessmentCharts.overallCRFS2025maturity;
				console.log('overallMaturityScore for CRF-S 2025 is '+WebAssessmentCharts.overallCRFS2025maturity);
			}
			// crf-s 2026 (Core + sub-versions)
			else if (framework_slug === 'crf-s-2026' || framework_slug === 'crf-s-appsec-2026' || framework_slug === 'crf-s-gov-2026' || framework_slug === 'crf-s-hyg-2026' || framework_slug === 'crf-s-smb-2026') {
				console.log('crf-s 2026 detected');
				if (is2026SubVersionSlug(framework_slug)) {
					overallMaturityScore = getTechnicalTableOverallScore();
				}
				overallMaturityScore = overallMaturityScore || WebAssessmentCharts.overallCRFS2026maturity || window.overallCRFS2026maturity;
				console.log('overallMaturityScore for CRF-S 2026 is '+WebAssessmentCharts.overallCRFS2026maturity);
			}
			// cis 7.0
			else if (framework_slug === 'cis-7-0') {
				console.log('cis 7.0 detected');
				overallMaturityScore = WebAssessmentCharts.overallCIS70maturity;
				console.log('overallMaturityScore for CIS 7.0 is '+WebAssessmentCharts.overallCIS70maturity);
			}
			// cis 7.1
			else if (framework_slug === 'cis-7-1') {
				console.log('cis 7.1 detected');
				overallMaturityScore = WebAssessmentCharts.overallCIS71maturity;
				console.log('overallMaturityScore for CIS 7.1 is '+WebAssessmentCharts.overallCIS71maturity);
			}
			// cis 8.0
			else if (framework_slug === 'cis-8-0') {
				console.log('cis 8.0 detected');
				overallMaturityScore = WebAssessmentCharts.overallCIS80maturity;
				console.log('overallMaturityScore for CIS 8.0 is '+WebAssessmentCharts.overallCIS80maturity);
			}
			// cis 8.1
			else if (framework_slug === 'cis-8-1') {
				console.log('cis 8.1 detected');
				overallMaturityScore = WebAssessmentCharts.overallCIS81maturity;
				console.log('overallMaturityScore for CIS 8.1 is '+WebAssessmentCharts.overallCIS81maturity);
			}
			// nist 1
			else if (framework_slug === 'nist-csf-1-0') {
				console.log('nist 1 detected');
				overallMaturityScore = WebAssessmentCharts.overallNIST1maturity;
				console.log('overallMaturityScore for NIST 1 is '+WebAssessmentCharts.overallNIST1maturity);
			}
			// nist 1.1
			else if (framework_slug === 'nist-csf-1-1') {
				console.log('nist 1.1 detected');
				overallMaturityScore = WebAssessmentCharts.overallNIST11maturity;
				console.log('overallMaturityScore for NIST 1.1 is '+WebAssessmentCharts.overallNIST11maturity);
			}
			// nist 2
			if (framework_slug === 'nist-csf-2-0') {
				overallMaturityScore = WebAssessmentCharts.overallNIST2maturity;
			}
			// nydfs/nycrr
			if (framework_slug === 'nycrr-500-v2') {
				console.log('nydfs/nycrr detected');
				overallMaturityScore = WebAssessmentCharts.overallNYCRR5002maturity;
				console.log('overallMaturityScore for NYDFS/NYCFR 2021 is '+WebAssessmentCharts.overallNYCRR5002maturity);
			}
			// SA NCA ECC 1.0
			if (framework_slug === 'sa-nca-ecc-1-0') {
				console.log('sa-nca-ecc detected');
				overallMaturityScore = WebAssessmentCharts.overallSANCAECCmaturity;
				console.log('overallMaturityScore for SA NCA ECC 1.0 is '+WebAssessmentCharts.overallSANCAECCmaturity);
			}
			// PCI DSS v4.0
			if (framework_slug === 'pci-dss-4-0') {
				console.log('pci-dss detected');
				overallMaturityScore = WebAssessmentCharts.overallPCIDSSmaturity;
				console.log('overallMaturityScore for PCI DSS v4.0 is '+WebAssessmentCharts.overallPCIDSSmaturity);
			}
			// SAMA CRFR v1.0
			if (framework_slug === 'sama-crfr-1-0') {
				console.log('sama-crfr detected');
				overallMaturityScore = WebAssessmentCharts.overallSAMACRFRmaturity;
				console.log('overallMaturityScore for SAMA CRFR v1.0 is '+WebAssessmentCharts.overallSAMACRFRmaturity);
			}
			// NIST SP 800-171 (rev3)
			if (framework_slug === 'nist-800-171-rev3') {
				console.log('nist-800-171-rev3 detected');
				overallMaturityScore = WebAssessmentCharts.overallNIST800171Rev3maturity;
				console.log('overallMaturityScore for NIST SP 800-171 (rev3) is '+WebAssessmentCharts.overallNIST800171Rev3maturity);
			}
		}
		// else user is on dashboard page
		fetch(projectData.ajax_url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			body: new URLSearchParams({
				action: 'update_project_completed',
				completed: true,
				project_id: projectId,
				current_user_id: projectData.current_user_id,
				framework_id: framework_id,
				framework_slug: framework_slug,
				overallMaturityScore: overallMaturityScore,
				nonce: projectData.nonce,
			}),
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error('Network response was not ok');
				}
				return response.json();
			})
		.then((data) => {
			if (data.success) {
				triggerConfetti();
				jQuery('#completeConfirmModal .modal-body').text('Assessment data has been successfully finalized.');
				jQuery('#completeConfirmModal .modal-footer').hide();
				console.log('Project completed field updated successfully:', data);
				if (jQuery('#viewResultsModal').is(':visible')) {
					sessionStorage.setItem('openViewResultsAfterReload', '1');
				}
				setTimeout(function() {
					window.location.reload();
				}, 1000);
			} else {
				console.error('Error updating project completed field:', data);
				if (data.data.message === 'User is not project owner') {
					jQuery('.permissions-user-not-owner').slideDown();
				}
			}
		})
		.catch((error) => {
			console.error('Error updating project completed field:', error);
		});
}
}
